import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventWithRelationsDto, ResponseDto } from "@mimber/schema"
import { eventsKeys } from "../events.utils"
import type { UsePublishEventOptions } from "./usePublishEvent.types"

export const usePublishEvent = (
  eventUuid: string,
  options: UsePublishEventOptions = {}
): UseMutationResult<ResponseDto<EventWithRelationsDto>, Error, void> => {
  guardAppUsage("mimber-organization", "usePublishEvent")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<EventWithRelationsDto>>(
        `events/${eventUuid}/publish`,
        {}
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findAll(),
      })
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findOne(eventUuid),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
